<template>
  <b-modal v-model="show" centered title="Edit country" hide-footer>
    <div class="d-block mx-2">
      <b-form @submit="saveCountry">
        <div class="mb-3">
          <label>Country Id:</label>
          <b-form-input v-model="country.id" disabled type="text" />
        </div>
        <div class="mb-3">
          <label>Name:</label>
          <b-form-input v-model="country.name" type="text" required />
        </div>
        <div class="mb-3">
          <label>ISO:</label>
          <b-form-input v-model="country.iso" type="text" />
        </div>
        <div class="mb-3">
          <label>Alt names:</label>
          <b-form-textarea v-model="country.alt_name" rows="2" />
        </div>
        <div class="mb-3">
          <label>Icon filename:</label>
          <b-form-input v-model="country.icon_filename" type="text" />
        </div>
        <div class="mb-3">
          <label>Is virtual:</label>
          <b-form-select v-model="country.is_virtual" :options="selectOptions" />
        </div>
        <div class="mb-3">
          <label>Dismissed:</label>
          <b-form-select v-model="country.dismissed" :options="selectOptions" />
        </div>

        <div class="d-flex justify-content-center mt-3 mb-3">
          <b-button type="submit" variant="primary">Save country</b-button>
        </div>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import { useActAdminApi } from '@/use/actAdminApi'

export default {
  emits: ['hideModal', 'countrySaved'],
  props: {
    showModal: Boolean,
    countryData: Object
  },
  data: () => {
    return {
      show: false,
      country: {},
      selectOptions: [
        { value: 0, text: 'No' },
        { value: 1, text: 'Yes' }
      ]
    }
  },
  watch: {
    showModal() {
      this.show = this.$props.showModal
    },
    show(val) {
      if (!val) {
        this.$emit('hideModal')
        this.country = {}
      } else {
        this.country = this.countryData
        if (!this.country.icon_filename) this.country.icon_filename = 'countries/no_icon.png'
        this.country.is_virtual = this.country.is_virtual ? 1 : 0
        this.country.dismissed = this.country.dismissed ? 1 : 0
      }
    }
  },
  setup() {
    const { initApiInst, actMappingApi } = useActAdminApi()
    return { initApiInst, actMappingApi }
  },
  methods: {
    async saveCountry(event) {
      event.preventDefault()
      await this.updateCountry()
    },
    async updateCountry() {
      const country = this.country
      const countryId = country.id
      if (!countryId) return
      const updatedCountryData = Object.assign({}, country)
      delete updatedCountryData.id
      try {
        await this.initApiInst()
        const resp = await this.actMappingApi.updateCountry(countryId, { country: updatedCountryData })
        if (resp.result && resp.result === 'success') {
          this.$store.commit('alert/add', {
            id: Date.now(),
            text: 'Country successfully updated',
            timeout: 3000,
            type: 'success',
            name: 'success_country_updated'
          })
          this.$emit('countrySaved', this.country)
        }
      } catch (e) {
        this.$store.commit('alert/add', {
          id: Date.now(),
          text: 'Update country error. Try again later',
          timeout: 3000,
          type: 'error',
          name: 'error_country_update'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
label {
  color: #686868;
}
</style>
